// Slack no painel de métricas: estado (configurado? quem responde por cada app?) e a lista de
// pessoas, buscada uma vez por visita. O servidor é api/slack.ts.

export interface Responsavel {
  app: string; // slug do app, ou "*" para os demais
  slack_id: string;
  nome: string;
}

export interface EstadoSlack {
  configurado: boolean;
  responsaveis: Responsavel[];
}

export interface PessoaSlack {
  id: string;
  nome: string;
  foto: string | null;
}

export interface Aviso {
  por: string;
  quando: string;
}

export const chamarSlack = (corpo: unknown) =>
  fetch("/api/slack", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify(corpo),
  });

let pessoas: Promise<PessoaSlack[]> | null = null;

export const carregarPessoas = () => {
  if (!pessoas) {
    pessoas = chamarSlack({ acao: "pessoas" })
      .then(async (r) => (r.ok ? ((await r.json()).pessoas as PessoaSlack[]) : Promise.reject(new Error(String(r.status)))))
      .catch((e) => {
        pessoas = null; // tenta de novo na próxima abertura
        throw e;
      });
  }
  return pessoas;
};

// Responsável de um app: o do slug (português ou espanhol), senão o padrão.
export const responsavelDo = (estado: EstadoSlack | null, slugs: string[]) =>
  estado?.responsaveis.find((r) => slugs.includes(r.app)) || estado?.responsaveis.find((r) => r.app === "*") || null;

export const MENSAGEM_ERRO_SLACK: Record<string, string> = {
  ja_avisado: "Essa pergunta acabou de ser avisada no Slack.",
  limite: "Limite de avisos por hora atingido. Tente mais tarde.",
  indisponivel: "Não consegui enviar ao Slack. Confira se o app Central de Ajuda está no canal.",
  sessao: "Sua sessão terminou. Entre de novo.",
};
